// extracted by mini-css-extract-plugin
export default {"notification":"style_notification__ZQxeF","close-btn":"style_close-btn__a2duZ","close-icon":"style_close-icon__TDiCN","default":"style_default__Qngmd","read":"style_read__5ZE6f"};